import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeCurlyBraceAnnotationRight extends Shape {
    width = 200;
    height = 182;
    needFill = false;
    fillStyleEnabled = false;
    borderStyleEnabled = false;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width * 0.75 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width * 0.75 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 12, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 50;

        const horizontalLineW = w * 0.2;
        const horizontalLineH = h * 0.38;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.arcTo(x + horizontalLineW, y, x + horizontalLineW, y + horizontalLineH, r);
        canv.ctx.lineTo(x + horizontalLineW, y + horizontalLineH);
        canv.ctx.lineTo(x + w * 0.325, y + h / 2);
        canv.ctx.lineTo(x + horizontalLineW, y + h - horizontalLineH);
        canv.ctx.arcTo(x + horizontalLineW, y + h, x, y + h, r);
        canv.ctx.lineTo(x, y + h);
        canv.ctx.moveTo(x, y + h);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linejoin="round" d="M1 2h4.46v7.7L7.42 12l-1.96 2.3V22H1M11.17 8.56H23m-11.83 3.58H23m-11.83 3.22h8.88"/>
            </svg>
        `;
    }
}
